import React, { useState } from "react";
import "./Home.css";
import logo from "./img/logo.png";

function Home() {
  // fixed header

  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header");
    header.classList.toggle("active", window.scrollY > 0);
  });
  // Toggle Menu
  const [show, setShow] = useState(false);

  const handleSideBarClose = () => {
    setShow(false);
  };
  return (
    <div className="home" id="Home">
      <div className="home__bg">
        <div className="header d__flex align__items__center pxy__30">
          <div className="logo">
            <img src={logo} alt="" />
          </div>
          <div className="navigation pxy__30">
            <ul className="navbar d__flex">
              <a href="#Home">
                <li className="nav__items mx__15">Home</li>
              </a>
              <a href="#About">
                <li className="nav__items mx__15">About</li>
              </a>
              <a href="#Services">
                <li className="nav__items mx__15">Services</li>
              </a>
              <a href="#Portfolio">
                <li className="nav__items mx__15">Projects</li>
              </a>
              <a href="#Contact">
                <li className="nav__items mx__15">Contact</li>
              </a>
            </ul>
          </div>
          {/* {Toggle Menu}	   */}
          <div className="toggle__menu">
            <i
              onClick={() => setShow(!show)}
              className={`iconToggle fa-solid ${show ? "fa-xmark" : "fa-bars"}`}
            ></i>
          </div>
          {show ? (
            <div className="sideNavbar">
              <ul className="sidebar d__flex">
                <li className="sideNavbar" onClick={handleSideBarClose}>
                  <a href="#Home">Home</a>
                </li>
                <li className="sideNavbar" onClick={handleSideBarClose}>
                  <a href="#About">About</a>
                </li>
                <li className="sideNavbar" onClick={handleSideBarClose}>
                  <a href="#Services">Services</a>
                </li>
                <li className="sideNavbar" onClick={handleSideBarClose}>
                  <a href="#Portfolio">Projects</a>
                </li>
                <li className="sideNavbar" onClick={handleSideBarClose}>
                  <a href="#Contact">Contact</a>
                </li>
              </ul>
            </div>
          ) : null}
        </div>
        {/* {HOME CONTENT} */}

        <div className="container">
          <div className="home__content">
            <div className="home__meta">
              <h1 className="home__text pz__10">WELCOME TO MY WORLD</h1>
              <h2 className="home__text pz__10">Hi, I'm Baraka Ganai</h2>
              <h3 className="home__text sweet pz__10">
                Full-Stack Web Developer.
              </h3>
              {/* <h4 className="home__text pz__10">Based In Mern-stack</h4> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
